import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import segmentMiddleware from './segment-middleware';

import applicationReducer from 'state/reducers/applicationReducer';
import viewReducer from 'state/reducers/viewReducer';
import questionnaireReducer from 'state/reducers/questionnaireReducer';
import qualifyReducer from 'state/reducers/qualifyReducer';

import statusReducer from 'state/reducers/statusReducer';
import errorReducer from 'state/reducers/errorReducer';

import { routerReducer, routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

const history = createHistory();

export default createStore(
  combineReducers({
    applicationState: applicationReducer,
    statusState: statusReducer,
    viewState: viewReducer,
    questionnaireState: questionnaireReducer,
    errorState: errorReducer,
    qualifyState: qualifyReducer,
    routerState: routerReducer
  }),
  composeWithDevTools(applyMiddleware(thunk, promiseMiddleware(), routerMiddleware(history), segmentMiddleware))
);

export { history };



// WEBPACK FOOTER //
// ./src/state/store.js